<template>
	<div class="topic_sum">
		<div class="container-fluid">
			<!-- Begin page -->
			<div class="wrapper">
				<div class="content-page">
					<div class="content">
						<div class="row">
							<div class="col-12">
								<div class="card">
									<div class="card-body">
										<div class="body-nav">
											<div class="nav-left">我提交的作品</div>
											<div class="pagination">
												<el-input placeholder="请输入通知名称查询" v-model="input" clearable></el-input>
												<el-button type="primary" style="margin-left: 20px;" @click="getMyWork">查询</el-button>
											</div>
										</div>
										<el-table id="table" :header-cell-style="tableStyle" border :data="submittedWorks" style="width: 100%;margin-bottom: 20px;">
											<el-table-column prop="projectName" label="通知名称" width="350">
												<template slot-scope="scope">
													<div style="color: #409EFF;cursor: default;" @click="checkName(scope.row)">{{ scope.row.projectName }}</div>
												</template>
											</el-table-column>
											<el-table-column prop="projectTypeName" label="提交作品类型" width="120"></el-table-column>
											<el-table-column prop="declareEndTime" label="提交截止时间"></el-table-column>
											<el-table-column prop="submittedNum1" label="已提交材料" width="100"></el-table-column>
											<el-table-column label="操作">
												<template slot-scope="scope">
													<el-button v-if="scope.row.isEnd" type="primary" @click="checkName(scope.row)">上传</el-button>
													<el-button type="text" style="color: #d4d4d4;" v-if="!scope.row.isEnd">上传已截止</el-button>
													<el-button type="text" @click="goRoute(scope.row)" style="margin-left: 20px;">查看作品</el-button>
												</template>
											</el-table-column>
										</el-table>
										<div class="pagination">
											<el-pagination
												@size-change="handleSizeChange"
												@current-change="handleCurrentChange"
												:current-page="pageNumber"
												:page-sizes="[50, 100, 200]"
												:page-size="pageSize"
												layout="total, sizes, prev, pager, next, jumper"
												:total="underStudyTopicTotal"
											></el-pagination>
										</div>
									</div>
								</div>
								<!-- end card -->
							</div>
							<!-- end col-->
						</div>
					</div>
				</div>
			</div>
			<!-- end wrapper-->
		</div>
	</div>
</template>

<script>
import { getProjectList, getPageListReview, delReview, getInfo1 } from '@/api/after/newInterface';
export default {
	data() {
		return {
			tableStyle: {
				backgroundColor: '#7e9be2',
				color: '#fff',
				textAlign: 'center'
			},
			submittedWorks: [],
			topicSumData: [],
			underStudyTopicTotal: 10,
			pageNumber: 1,
			pageSize: 20,
			input: '',
			mulSelectVal: [],
			isShow: false,
			topicSumData2: [],
			checkNames: '',
			ids: ''
		};
	},
	filters: {
		rowState(val) {
			switch (val) {
				case 0:
					return '未初审';
					break;
				case 1:
					return '初审通过';
					break;
				case 2:
					return '初审未通过';
					break;
				case 3:
					return '终审通过';
					break;
				case 4:
					return '终审未通过';
					break;
				case 5:
					return '提交截止';
					break;
				default:
					break;
			}
		}
	},
	mounted() {
		this.getMyWork();
	},
	methods: {
		//我提交的作品
		getMyWork() {
			let params = {
				pageNumber: this.pageNumber,
				pageSize: this.pageSize,
				type: 4,
				projectName: this.input,
				teacher:1
			};
			getProjectList(params).then(res => {
				if (res.code == 200) {
					this.submittedWorks = res.data.records;
					this.underStudyTopicTotal = res.data.total;
				} else {
					this.$message.error(res.msg);
				}
			});
		},
		handleSizeChange(val) {
			this.pageSize = val;
			this.getMyWork();
		},
		handleCurrentChange(val) {
			this.pageNumber = val;
			this.getMyWork();
		},
		checkName(row) {
			sessionStorage.setItem('workId', row.id);
			this.$router.push(`/backstage/submitStateCollective?rowId=${row.id}`);
		},
		goRoute(row) {
			sessionStorage.setItem('workId', row.id);
			this.$router.push(`/backstage/submitStateCollective?rowId=${row.id}`);
		}
	}
};
</script>

<style scoped lang="scss">
::v-deep .el-date-editor.el-input {
	width: 100%;
}
.btn_wrap {
	margin-bottom: 20px;
	display: flex;
	align-items: center;
	// justify-content: space-between;
}
.pagination {
	display: flex;
	justify-content: center;
}
.body-nav {
	display: flex;
	align-items: center;
	justify-content: space-between;
	margin-bottom: 10px;
	.nav-left {
		font-size: 20px;
	}
}
.nav-date {
	color: red;
	font-size: 15px !important;
	margin-left: 80px;
}
</style>
